import classNames from 'classnames';
import React from 'react';

import NumberInput from 'sharedreact/components/NumberInput';
import ParameterComponent from 'sharedreact/components/ParameterComponent';

type Props = {
  id: string,
  className?: string,
  name: string,
  label: string,
  labelClassName?: string,
  value: number | string, // string in case an empty string was entered or the string can't be converted into a number
  decimals: number,
  precision?: number,
  greaterThanOrEqualTo?: number,
  greaterThan?: number,
  lessThanOrEqualTo?: number,
  lessThan?: number,
  disabled?: boolean,
  children?: React.ReactNode,
  validationTooltipPlacement?: string,
  validationTooltipClassName?: string,

  onChangeValue?: (name: string, value: string | number, event?: React.FocusEvent<HTMLInputElement, Element>) => void
};

class NumberField extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, className, name, label, labelClassName, value, decimals, precision,
      greaterThanOrEqualTo, greaterThan, lessThanOrEqualTo, lessThan,
      disabled,
      children, validationTooltipPlacement, validationTooltipClassName,
      onChangeValue
    } = this.props;

    return (
      <ParameterComponent
        className={classNames(className, 'esko_parameter-input-max150')}
        inputId={id}
        label={label}
        labelClassName={labelClassName}
        inputContainer={!!children}
      >
        <NumberInput
          className={classNames({esko_forminput: !children})}
          id={id}
          name={name}
          value={value}
          decimals={decimals}
          precision={precision}
          greaterThanOrEqualTo={greaterThanOrEqualTo}
          greaterThan={greaterThan}
          lessThanOrEqualTo={lessThanOrEqualTo}
          lessThan={lessThan}
          disabled={disabled}
          validationTooltipPlacement={validationTooltipPlacement}
          validationTooltipClassName={validationTooltipClassName}
          onChangeValue={onChangeValue}
        >
          {children}
        </NumberInput>
      </ParameterComponent>
    );
  }
}

export default NumberField;
